<template>
	<div class="flex flex-wrap relative px-6 py-10 lg:px-0">
		<div class="absolute top-14 right-6 lg:hidden z-20">
			<div class="flex">
				<a @click.prevent="slidePrev" class="pl-4" href="#">
					<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M11.6372 7.50993L15 15L8.93181e-08 7.50993L15 -7.74801e-07L11.6372 7.50993Z" fill="#E35E5C"/>
					</svg>
				</a>
				<a @click.prevent="slideNext" class="pl-6" href="#">
					<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.36277 7.49007L9.53674e-07 -6.55671e-07L15 7.49007L2.98003e-07 15L3.36277 7.49007Z" fill="#E35E5C"/>
					</svg>
				</a>
			</div>
		</div>
		<div class="w-full hidden lg:block lg:w-1/12">
			<div class="flex h-full w-full items-center justify-start">
				<a @click.prevent="slidePrev" href="#">
					<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M11.6372 7.50993L15 15L8.93181e-08 7.50993L15 -7.74801e-07L11.6372 7.50993Z" fill="#E35E5C"/>
					</svg>
				</a>
			</div>
		</div>
		<div class="w-full lg:w-10/12">
			<swiper
					ref="stagesSwiper"
					:options="swiperOptions"
					@slideChange="changeIndex"
			>
				<swiper-slide v-for="(stage, index) in stages"  v-bind:key="'slidestage'+index">
					<div class="flex flex-wrap">
						<div class="w-full lg:w-1/2">
							<div class="flex flex-col h-full w-full">
								<div>
									<h3 class="text-xl lg:text-2xl uppercase text-hamlet-red" v-html="stage.heading"></h3>
									<h2 class="text-hamlet-red" v-html="stage.name"></h2>
									<div class="lg:w-8/12" v-html="stage.content"></div>
								</div>
								<div class="mt-auto">
									<div class="w-full lg:w-8/12">
										<div class="flex justify-between w-full">
											<h5>No. of lots</h5>
											<span class="text-xl lg:text-2xl" v-html="stage.lots"></span>
										</div>
										<div class="flex justify-between w-full">
											<h5>Size range (sqm)</h5>
											<span class="text-xl lg:text-2xl" v-html="stage.sqm"></span>
										</div>
									</div>

									<div class="pt-4">
										<a :href="stage.flyer" target="_blank" class="cta mb-10 stage-download">
											<span>Download stage flyer</span>
											<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0)">
													<path d="M2.34501 5.61755L5.34058e-05 0L10.46 5.61755L5.34058e-05 11.25L2.34501 5.61755Z" fill="#F4D995"/>
												</g>
												<defs>
													<clipPath id="clip0">
														<rect width="11.25" height="10.4599" fill="white" transform="translate(10.46) rotate(90)"/>
													</clipPath>
												</defs>
											</svg>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="w-full lg:w-1/2">
							<img :src="stage.image" :alt="`${stage.heading} ${stage.name}`" />
						</div>
					</div>
				</swiper-slide>
			</swiper>
		</div>
		<div class="w-full hidden lg:block lg:w-1/12">
			<div class="flex h-full w-full items-center justify-end">
				<a @click.prevent="slideNext" href="#">
					<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.36277 7.49007L9.53674e-07 -6.55671e-07L15 7.49007L2.98003e-07 15L3.36277 7.49007Z" fill="#E35E5C"/>
					</svg>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
	name: "stages",
	props: {
		stages: {
			type: Array,
			default: () => []
		},
	},
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {
			swiperOptions: {
				loop: true,
				slidesPerView: 1,
				centeredSlides: true,
				centeredSlidesBounds: true,
				initialSlide: 0,
				allowTouchMove: false
			},
			activeIndex: null,
		}
	},
	computed: {
		swiper() {
			if(!this.$refs.stagesSwiper) return null;
			return this.$refs.stagesSwiper.$swiper;
		},
		activeSlide() {
			if(this.activeIndex===null){ return false; }
			return this.stages[this.activeIndex];
		},
	},
	methods: {
		slideNext(){
			this.swiper.slideNext()
			this.swiperMobile.slideNext()
		},
		slidePrev(){
			this.swiper.slidePrev()
			this.swiperMobile.slidePrev()
		},
		changeIndex(){
			this.activeIndex = this.swiper.realIndex
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.activeIndex = this.swiper.activeIndex;
		})
	}
}
</script>

<style scoped>

</style>
